/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Common_VersionInputs */

const en_pc_common_version = /** @type {(inputs: Pc_Common_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

const zh_pc_common_version = /** @type {(inputs: Pc_Common_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`版本 ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Version {version}" |
*
* @param {Pc_Common_VersionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_version = /** @type {((inputs: Pc_Common_VersionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_VersionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_version(inputs)
	return zh_pc_common_version(inputs)
});
export { pc_common_version as "pc.common.version" }